<ng-container [ngSwitch]="statusNumber">
  <ng-container
    *ngSwitchCase="0"
    [ngTemplateOutlet]="projectTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="1"
    [ngTemplateOutlet]="cclContactTemplate"
  ></ng-container>
  <ng-container
    *ngSwitchCase="2"
    [ngTemplateOutlet]="cclContactTemplate"
  ></ng-container>
</ng-container>

<ng-template #projectTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        dataSourceArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter contacts</mat-label>
          <input
            matInput
            (keyup)="filterProjects($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="projectDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Customer Name
          </th>
          <td mat-cell *matCellDef="let project">
            {{ project.customerName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobaddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
          <td mat-cell *matCellDef="let project">
            {{ project.jobaddress | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="estimatorName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimator</th>
          <td mat-cell *matCellDef="let project">
            {{ project.estimatorName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="soldByName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sold By</th>
          <td mat-cell *matCellDef="let project">
            {{ project.soldByName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="approvalDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Approval Date
          </th>
          <td mat-cell *matCellDef="let project">
            {{ project.approvalDate | date : "shortDate" : "UTC" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="contractDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Contract Date
          </th>
          <td mat-cell *matCellDef="let project">
            {{ project.contractDate | date : "shortDate" : "UTC" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="projectShortName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Project Type
          </th>
          <td mat-cell *matCellDef="let project">
            {{ project.projectShortName }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="projectDisplayedColumns; sticky: true"
        ></tr>

        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td class="mat-cell" [attr.colspan]="projectDisplayedColumns.length">
            No matching results
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: projectDisplayedColumns"
          (click)="goToCCLContact(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>

<ng-template #cclContactTemplate>
  <div class="header">
    <h1>{{ statusMessage }}</h1>
    <mat-chip-list *ngIf="statusMessage">
      <mat-chip color="primary" selected class="count-chip">{{
        dataSourceArray.length || 0
      }}</mat-chip>
    </mat-chip-list>
  </div>
  <div class="table-container">
    <div class="content">
      <div class="filter">
        <mat-form-field appearance="standard">
          <mat-label>Filter contacts</mat-label>
          <input
            matInput
            (keyup)="filterCCLContacts($event)"
            #input
            placeholder="ex. John Doe"
          />
        </mat-form-field>
      </div>

      <table
        mat-table
        [dataSource]="cclContactDataSource"
        class="table"
        matSort
        fixedLayout="true"
      >
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Customer Name
          </th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.customerName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="contactStageName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Contact Stage
          </th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.contactStageName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="jobAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.jobAddress | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="estimatorName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimator</th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.estimatorName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="soldByName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sold By</th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.soldByName | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="approvalDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Approval Date
          </th>
          <td mat-cell *matCellDef="let project">
            {{ project.approvalDate | date : "shortDate" : "UTC" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="contractDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Contract Date
          </th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.contractDate | date : "shortDate" : "UTC" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="projectShortName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Project Type
          </th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.projectShortName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="updatedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Last Contacted By
          </th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.updatedBy }}
          </td>
        </ng-container>
        <ng-container matColumnDef="updatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Last Contact Date
          </th>
          <td mat-cell *matCellDef="let cclContact">
            {{ cclContact.updatedDate | date : "shortDate" : "UTC" }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="cclContactDisplayedColumns; sticky: true"
        ></tr>

        <tr
          class="mat-row"
          *matNoDataRow
          [ngStyle]="{ 'text-align': 'center' }"
        >
          <td
            class="mat-cell"
            [attr.colspan]="cclContactDisplayedColumns.length"
          >
            No matching results
          </td>
        </tr>
        <tr
          mat-row
          *matRowDef="let row; columns: cclContactDisplayedColumns"
          (click)="goToCCLContact(row)"
        ></tr>
      </table>

      <div *ngIf="isLoading" class="spinner">
        <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
      </div>

      <mat-paginator
        [pageSize]="100"
        [pageSizeOptions]="[10, 50, 100, 150, 500]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
</ng-template>
